// Cross-check every scorer's card within each group. Only strokes are verified.
export function verifyDay(day) {
  const groups = (day?.groups || []).map((g, gi) => {
    const cards = g.cards || {};
    const missing = [];
    for (const scorerId of g.playerIds) {
      const card = cards[scorerId];
      let holesMissing = 0;
      for (let h = 0; h < 18; h++) {
        if (!g.playerIds.every((pid) => card?.[pid]?.[h])) holesMissing++;
      }
      if (holesMissing > 0) missing.push({ scorerId, holesMissing, started: !!card });
    }
    const discrepancies = [];
    for (const pid of g.playerIds) {
      for (let h = 0; h < 18; h++) {
        const values = {};
        for (const scorerId of g.playerIds) {
          const v = cards[scorerId]?.[pid]?.[h];
          if (v) values[scorerId] = v;
        }
        if (new Set(Object.values(values)).size > 1) {
          discrepancies.push({ playerId: pid, holeIdx: h, values, official: g.scores?.[pid]?.[h]?.strokes ?? null });
        }
      }
    }
    return { gi, missing, discrepancies };
  });
  const missingCount = groups.reduce((a, g) => a + g.missing.length, 0);
  const discrepancyCount = groups.reduce((a, g) => a + g.discrepancies.length, 0);
  return { groups, missingCount, discrepancyCount, ok: missingCount === 0 && discrepancyCount === 0 };
}

// Per-group round status: official holes completed, missing holes, card check, attestations, submission.
export function groupStatus(day, gi) {
  const g = (day?.groups || [])[gi];
  if (!g) return null;
  const ids = g.playerIds || [];
  const missingHoles = [];
  let lastPlayed = -1;
  for (let h = 0; h < 18; h++) {
    const all = ids.every((pid) => g.scores?.[pid]?.[h]?.strokes);
    if (ids.some((pid) => g.scores?.[pid]?.[h]?.strokes)) lastPlayed = h;
    if (!all) missingHoles.push(h);
  }
  const check = verifyDay(day).groups[gi];
  const attestations = g.attestations || {};
  const attested = ids.filter((pid) => attestations[pid]);
  return {
    group: g,
    holesDone: 18 - missingHoles.length,
    missingHoles,
    complete: missingHoles.length === 0,
    lastPlayed,
    missingCards: check.missing,
    discrepancies: check.discrepancies,
    cardsAgree: check.missing.length === 0 && check.discrepancies.length === 0,
    attested,
    pendingAttest: ids.filter((pid) => !attestations[pid]),
    submitted: g.submitted || null,
  };
}

export function daySubmissions(day) {
  const groups = (day?.groups || []).map((_, gi) => groupStatus(day, gi));
  const submitted = groups.filter((s) => s.submitted).length;
  return { groups, submitted, total: groups.length, allIn: groups.length > 0 && submitted === groups.length };
}
